import {HTTP} from "./common";

export const WatchLinkApi = {
    add(data) {
        return HTTP.post(`watch_links/add_link/`, data).then((response) => {
            return response.data;
        });
    },
    remove(data) {
        return HTTP.post(`watch_links/remove_link/`, data).then((response) => {
            return response.data;
        });
    },

    list(query) {
        return HTTP.get(`watch_links/watch_stat/?${query}`).then((response) => {
            return response.data;
        });
    },


    delete(id) {
        return HTTP.delete(`watch_links/${id}/`).then((response) => {
            return response.data;
        });
    },

    get_report_data(filter) {
        return HTTP.get(`watch_links/get_report_data/?${filter ? filter : ""}`).then(
            (response) => {
                return response.data;
            }
        );
    },


};
